<template>
  <div class="">

    <input type="number" class="text-left form-control" v-model="tempValue">

  </div>
</template>


<script>
import {calculatePriceAndOffer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "CreateOrderOfferPriceManager.vue",
  props: {
    mode: {
      default: 'price' // valid values: price, offer
    },
    product: {},
    subProduct: {
      default: null
    }
  },
  data() {
    return {
      tempValue: ''
    }
  },
  methods: {
    calculatePriceAndOffer,
    manageProductOfferPrice(value) {
      this.product[`custom_${this.mode}`] = value
    }
  },
  mounted() {
    this.tempValue = this.calculatePriceAndOffer(this.product, this.subProduct)[this.mode]
    this.tempValue = this.tempValue == null ? 0 : this.tempValue
    this.manageProductOfferPrice(this.tempValue)
  },
  watch: {
    tempValue: {
      handler(oldValue, newValue) {
        this.manageProductOfferPrice(this.tempValue)
        this.$emit('changeValue', true)
      },
      deep: true
    }
  }
}
</script>


<style scoped>

</style>